export default {
  onUpdate: registration => {
    registration.unregister().then(() => {
      if (window.confirm("Jest dostępna nowa wersja aplikacji. Czy chcesz ją teraz zaktualizować?")) {
        window.location.reload()
      }
    })
  },
  onSuccess: registration => {
    console.log('Service Worker registered');
  },
}